import styled from 'styled-components';

import * as fonts from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';
import { GROUP_BOX_PADDING_LEFT_RIGHT } from '@atlassian/help-center-common-component/group-box';

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled.div`
    flex: 1 1 auto;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const CategorySectionTitle = styled.h2`
    ${fonts.h500};
    display: flex;
    align-items: center;
    font-weight: 600;
    margin-bottom: 0;

    /* Targeting the first child (icon) and give it a margin. */
    /* We do this so we don't affect the flex alignment. */
    > :first-child {
        margin-right: ${token('space.100', '8px')};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const CategoryItems = styled.ul`
    padding: 0;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    margin: 0 -${GROUP_BOX_PADDING_LEFT_RIGHT} ${token('space.200', '16px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const CategoryItemContainer = styled.li`
    padding: 0;
    margin: 0;
    list-style: none;
`;
